export const placeholder = (field) => {
  switch (field) {
    case "email":
      return "Enter email address"
    case "departure":
      return "Departure Airport"
    case "description":
      return "Describe Item(s) to carry"
    case "items_quantity":
      return "Items Quantity"
    case "destination":
      return "Destination Airport"
    case "shipment_date":
      return "Shipment Date"
    case "vat":
      return "Optional"
    case "item_images":
      return "Item Images"
    case "delivery_address":
      return "Delivery Address"
    case "height":
      return "Approximate Height"
    case "lenght":
      return "Approximate Lenght"
    case "width":
      return "Approximate Width"
    case "weight":
      return "Approximate Weight"
    case "departure_airport":
      return "Departure airport"
    case "destination_airport":
      return "Destination Airport"
    case "sender_name":
      return "Sender Name"
    case "sender_email":
      return "Sender Email"
    case "sender_country":
      return "Sender Country"
    case "sender_airport":
      return "Sender Airport"
    case "receiver_name":
      return "Receiver Name"
    case "receiver_email":
      return "Receiver Email"
    case "receiver_country":
      return "Receiver Country"
    case "receiver_airport":
      return "Receiver Airport"
    case "discount_code":
      return "Do you have a discount code (Optional)?"
    default:
      return ""
  }
}
